const spacing = {
  base: 5,
  scale: {
    ratio: 2,
    base: 4
  }
};

export { spacing };
